// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"SearchResultsHeader_ProseMirror__nRr0a","header":"SearchResultsHeader_header__c7sMZ","rotate-shadow":"SearchResultsHeader_rotate-shadow__-VuAA"};